// @ts-ignore
/* eslint-disable */
///////////////////////////////////////////////////////////////////////
//                                                                   //
// this file is autogenerated by service-generate                    //
// do not edit this file manually                                    //
//                                                                   //
///////////////////////////////////////////////////////////////////////
/// <reference path = "api-auto.d.ts" />
import request from '@/utils/ajax'

/**
 * Update avatar of user
 */
export async function UserControllerUpdateAvatar(
  params: Paths.UserControllerUpdateAvatar.BodyParameters,
): Promise<{
  error: string
  data: Definitions.UserWithProfile
}> {
  // /v1/user/avatar
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/user/avatar`, {
    ..._params,
  })
}

/**
 * Get avatar of user
 */
export async function UserControllerGetAvatar(
  params: Paths.UserControllerGetAvatar.BodyParameters,
): Promise<{
  error: string
  data: Paths.UserControllerGetAvatar.Responses
}> {
  // /v1/user/avatar/{uid}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/user/avatar/${_params.uid}`, {
    params: _params,
  })
}

/**
 * get license upload sts
 */
export async function UserControllerGetLicenseSts(
  params: Definitions.LicenseUrlStsDto,
): Promise<{
  error: string
  data: Definitions.LicenseUrlObject
}> {
  // /v1/user/license/sts
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/user/license/sts`, {
    ..._params,
  })
}

/**
 * get company setting
 */
export async function UserControllerGetCompanySetting(
  params: Paths.UserControllerGetCompanySetting.BodyParameters,
): Promise<{
  error: string
  data: Definitions.UserCompanySetting
}> {
  // /v1/user/company
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/user/company`, {
    params: _params,
  })
}

/**
 * Create company setting
 */
export async function UserControllerCreateCompanySetting(
  params: Definitions.CreateSettingDto,
): Promise<{
  error: string
  data: Definitions.UserCompanySetting
}> {
  // /v1/user/company
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/user/company`, {
    ..._params,
  })
}

/**
 * Bind email
 */
export async function UserControllerBindEmail(
  params: Definitions.BindEmailDto,
): Promise<{
  error: string
  data: Definitions.UserWithProfile
}> {
  // /v1/user/bind/email
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/user/bind/email`, {
    ..._params,
  })
}

/**
 * Bind username
 */
export async function UserControllerBindUsername(
  params: Definitions.BindUsernameDto,
): Promise<{
  error: string
  data: Definitions.UserWithProfile
}> {
  // /v1/user/bind/username
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/user/bind/username`, {
    ..._params,
  })
}

/**
 * Get current user profile
 */
export async function UserControllerGetProfile(
  params: Paths.UserControllerGetProfile.BodyParameters,
): Promise<{
  error: string
  data: Definitions.UserWithProfile
}> {
  // /v1/user/profile
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/user/profile`, {
    params: _params,
  })
}
